import React, { useRef, useState } from "react";
import { CheckIcon, XIcon } from "../../../constants/Icons";

const CustomUnitAdd = ({ onclose, onSave }) => {
  const [unit, setUnit] = useState({
    name: "",
    code: "",
  });
  const nameRef = useRef(null);
  const codeRef = useRef(null);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    const filteredValue = value.replace(/[^A-Za-z]/g, "");
    if(name==="code"){
      filteredValue.slice(0,5);
    }

    setUnit((prev) => ({
      ...prev,
      [name]: filteredValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!unit.name.trim()) {
      newErrors.name = "Unit Name is required";
      nameRef.current.focus();
    }

    if (!unit.code.trim()) {
      newErrors.code = "Unit Code is required";
      codeRef.current.focus();
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;

    onSave(unit);
    onclose();
  };

  // ENTER KEY SUBMIT
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (e.target.name === "name") {
        if (!unit.name.trim()) {
          setErrors((prev) => ({
            ...prev,
            name: "Unit Name is required",
          }));
          return;
        }

        codeRef.current?.focus();
      }

      if (e.target.name === "code") {
        if (!unit.code.trim()) {
          setErrors((prev) => ({
            ...prev,
            code: "Unit Code is required",
          }));
          return;
        }

        handleSave();
      }
    }
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Add New Unit</h6>
              <button className="btn-close" onClick={onclose}></button>
            </div>

            <div className="modal-body bg-light">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="row g-3 align-items-center">
                    {/* Unit Name */}
                    <div className="col-12">
                      <label className="form-label">
                        Unit Name <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className={`form-control`}
                        ref={nameRef}
                        name="name"
                        autoComplete="off"
                        autoFocus
                        value={unit.name}
                        onFocus={(e) => e.target.select()}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                      />

                      {errors.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                      )}
                    </div>

                    {/* Unit Code */}
                    <div className="col-12">
                      <label className="form-label">
                        Unit Code <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className={`form-control`}
                        ref={codeRef}
                        name="code"
                        maxLength={5}
                        autoComplete="off"
                        value={unit.code}
                        onFocus={(e) => e.target.select()}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                      />

                      {errors.code && (
                        <div className="invalid-feedback">{errors.code}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={onclose}
              >
                <XIcon/> Close
              </button>

              <div className="btn-group text-right align-items-center">
                <button
                  className="btn btn-unit text-right"
                  onClick={handleSave}
                >
                  <CheckIcon iClass={"fs-15"}/> Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomUnitAdd;
